// Third-party
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Redux
import { ReduxState } from '../../../redux/modules/types';

// Utils
import { formatMessage } from '../../../utils/i18n';

// Components
import { Button } from '@capintel/component-lib/button';
import { openNotificationCenter, getAnnouncementCounts } from '../../../redux/modules/announcements/user';

type StateProps = {
  totalCount: number;
  unacknowledgedCount: number;
  unreadCount: number;
};

type DispatchProps = {
  openNotificationCenter: () => void;
  getAnnouncementCounts: () => Promise<StateProps>;
};

type Props = StateProps & DispatchProps;

const MAX_COUNT = 99;

class AnnouncementBell extends React.Component<Props> {
  componentDidMount() {
    this.props.getAnnouncementCounts();
  }

  renderCount = () => {
    const { unreadCount, unacknowledgedCount } = this.props;
    const count = Math.max(unreadCount, unacknowledgedCount);

    if (count) {
      const displayedCount = count > MAX_COUNT ? `+${MAX_COUNT}` : count;

      return <div className="unread-count">{displayedCount}</div>;
    }

    return null;
  };

  render() {
    return (
      <Button
        variant="secondary"
        appearance="text"
        onClick={this.props.openNotificationCenter}
        icon="notification-bell"
        aria-label={formatMessage('AnnouncementBell.IconLabel')}
      >
        {this.renderCount()}
      </Button>
    );
  }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  totalCount: state.userAnnouncements.totalCount,
  unacknowledgedCount: state.userAnnouncements.unacknowledgedCount,
  unreadCount: state.userAnnouncements.unreadCount,
});

export default connect(mapStateToProps, {
  openNotificationCenter,
  getAnnouncementCounts,
})(AnnouncementBell);
